import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { SiteProvider } from "@/lib/SiteContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCtaBar from "@/components/MobileCtaBar";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Residential from "@/pages/Residential";
import Commercial from "@/pages/Commercial";
import Specialised from "@/pages/Specialised";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Brand from "@/pages/Brand";
import Areas from "@/pages/Areas";
import AreaRegion from "@/pages/AreaRegion";
import AdminDocuments from "@/pages/admin/AdminDocuments";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        window.__lenis ? window.__lenis.scrollTo(el, { offset: -72 }) : el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.__lenis ? window.__lenis.scrollTo(0, { immediate: true }) : window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Layout = () => (
  <div className="flex min-h-screen flex-col">
    <Header />
    <main className="flex-1 pb-[57px] md:pb-0">
      <Outlet />
    </main>
    <Footer />
    <MobileCtaBar />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <ScrollManager />
          <Routes>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/documents" element={<AdminDocuments />} />
            <Route path="/brand" element={<Brand />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/areas" element={<Areas />} />
              <Route path="/areas/:slug" element={<AreaRegion />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/residential" element={<Residential />} />
              <Route path="/commercial" element={<Commercial />} />
              <Route path="/specialised" element={<Specialised />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-center" />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
